import { useNavigate } from 'react-router-dom';

import withReport from 'components/with-report';
import HRISIntegrationButton from 'components/import-data-page/hris-integration-button';
import GustoIntegrationButton from 'components/import-data-page/gusto-integration-button';
import { updateReport } from 'api/reports';
import { HRIS_GUSTO_PROVIDER, MERGE_HRIS_PROVIDERS } from 'constants/hris-providers';
import { DATA_UPLOAD_METHOD } from 'constants/common';
import { Report } from 'graphql-api';
import { reportCurrentStepPath } from 'utils/path';
import LockIcon from 'assets/images/lock-icon.svg';

function ImportDataPage({ report }: { report: Report }): JSX.Element {
  const navigate = useNavigate();

  function handleChooseUploadFileClick(): void {
    void (async () => {
      const updatedReport = await updateReport(report, { dataImportMethod: DATA_UPLOAD_METHOD });
      if (updatedReport !== null) {
        navigate(reportCurrentStepPath(updatedReport));
      }
    })();
  }

  return (
    <div className="max-w-6xl m-auto bg-white shadow mt-8 py-16 px-14">
      <div className="pb-12 border-b border-gray-200">
        <div className="text-2xl font-medium leading-6 text-gray-900">
          Import your employee data
        </div>
        <div className="text-base text-gray-700 mt-2 w-2/3">
          Securely connect to your Payroll or HR system to easily import data for your CA Pay Data
          Report. System not listed? Use the&nbsp;
          <a
            onClick={handleChooseUploadFileClick}
            className="cursor-pointer underline text-cornflower-blue">
            data upload template
          </a>
          .
        </div>
      </div>
      <div className="flex items-center p-2 border-b border-gray-200">
        <div className="flex-1 text-gray-900 text-sm">
          <img src={HRIS_GUSTO_PROVIDER.icon} className="inline w-6 mr-4 rounded-full" />
          {HRIS_GUSTO_PROVIDER.name}
        </div>
        <GustoIntegrationButton report={report} />
      </div>
      {MERGE_HRIS_PROVIDERS.map((hrisProvider, index) => (
        <div key={index} className="flex items-center p-2 border-b border-gray-200">
          <div className="flex-1 text-gray-900 text-sm">
            <img src={hrisProvider.icon} className="inline w-6 mr-4 rounded-full" />
            {hrisProvider.name}
          </div>
          <HRISIntegrationButton report={report} integration={hrisProvider.integration} />
        </div>
      ))}

      <div className="text-gray-900 text-xs text-center mt-8">
        <img src={LockIcon} className="inline" />
        &nbsp;
        <a href="http://trust.opencomp.com/" target="_blank" rel="noreferrer">
          OpenComp is SOC 2 Type II compliant
        </a>
      </div>
    </div>
  );
}

export default withReport(ImportDataPage);
